import apiClient from "./apiClient";

const teacherServices = {
  getTeacherByID: (teacherID) => {
    return apiClient.get(`/teachers/${teacherID}`);
  },
  getTeacherStats: () => {
    return apiClient.get("/teacher-stats");
  },
  getTeacherData: () => {
    return apiClient.get(`/teacher`);
  },
  getTeacherCourses: () => {
    return apiClient.get(`/teacher-courses`);
  },
  deleteTeacher: (teacherID) => {
    return apiClient.delete(`/teachers/${teacherID}`);
  },
  getStudentQuestionsAnswers: (lessonID, studentID) => {
    return apiClient.get(`/student-questions/${lessonID}/${studentID}`);
  },
  activationTeacher: (teacherID) => {
    return apiClient.get(`/activation-teacher/${teacherID}`);
  },
  getTeacherProjects: (IDEType) => {
    return apiClient.get(`/teacher-projects?type=${IDEType}`);
  },
  getTeacherProjectByID: (projectID) => {
    return apiClient.get(`/teacher-projects/${projectID}`);
  },
  createTeacherProjects: (payload) => {
    return apiClient.post(`/teacher-projects`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  editTeacherProjects: (projectID, payload) => {
    return apiClient.post(
      `/teacher-projects/${projectID}`,
      { _method: "PUT", ...payload },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  getClassroomsByTeacher: (
    teacherID,
    {
      page = 1,
      per_page = 9999,
      sort_by = "name",
      sort_dir = "asc",
      search = "",
      has_students = false,
      type = "",
    } = {}
  ) => {
    let url = teacherID ? `/teacher-classrooms/${teacherID}` : `/teacher-classrooms`;
    const params = new URLSearchParams({ page, per_page, sort_dir, sort_by });

    if (search) {
      params.append("search", search);
    }

    if (has_students) {
      params.append("has_students", has_students);
    }
    if (type) {
      params.append("type", type);
    }

    return apiClient.get(`${url}?${params.toString()}`);
  },

  editTeacherProfile: (teacherID, payload) => {
    return apiClient.post(`/teachers/${teacherID}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  getApproveDisapproveMessages(type) {
    return apiClient.get(`/messages/${type}`);
  },
  getStudentModifyingHistory(id) {
    return apiClient.get(`/student-project-history/${id}`);
  },

  approveStudentTask: (projectId, payload) => {
    return apiClient.post(`/student-project-response/${projectId}`, payload);
  },
};

export default teacherServices;
